import React, { useState, useEffect } from 'react';
import TableToolbox from '../../../../components/TableToolbox';
import { Strings } from '../../../../utils/strings';
import useStyles from './styles';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from '@mui/material';
import EnhancedTableHead from '../../../../components/DataTables/TableHead';
import {
  applySortFilter,
  getComparator,
  getErrorMessage,
  tableCell,
} from '../../../../utils/appUtils';
import { useTheme } from '@mui/material/styles';
import NewCategoryType from './NewCategoryType';
import { connect } from 'react-redux';
import { fetchCategoryList } from '../../../../redux/actions/jobActions/categoryActions/categoryTypeList';
import { CircularProgress } from '@material-ui/core';
import { useAlert } from 'react-alert';
import { icons } from '../../../../utils/icons';
import CommonDialog from '../../../../components/CommonDialog';
import CustomizedTooltips from '../../../../components/CustomizedTooltips';
import { deleteCategory } from '../../../../redux/actions/jobActions/categoryActions/deleteCetegoryType';

// ======== Table Head =========
const headCells = [
  { id: 'categoryName', label: 'TITLE', isSort: true },
  { id: 'status', label: 'STATUS', isSort: true },
  {
    id: '',
  },
];

const CategoryTypes = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [newDialog, setNewDialog] = useState(false);
  // const [categoryListData, setCategoryListData] = useState([]);
  const categoryListData = props.categoryListData || [];
  const [deleteCategorytDialog, setDeleteCategoryDialog] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [order, setOrder] = useState('asc');
  const [orderBy, setOrderBy] = useState('');

  const theme = useTheme();
  const alert = useAlert();
  const { state } = useLocation();

  const onError = (err) => {
    const error = getErrorMessage(err);
    if (error) {
      alert.error(error);
    }
  };

  useEffect(() => {
    props.fetchCategoryList(state && state.type ? state.type : 'form', (err) =>
      onError(err)
    );
  }, [
    props.addCategoryData,
    props.deleteCategoryData,
    props.updateCategoryData,
  ]);

  // useEffect(() => {
  //   const data = props.categoryListData ? props.categoryListData : [];
  //   setCategoryListData(data);
  // }, [props.categoryListData]);

  const onDeleteData = () => {
    props.deleteCategory(
      state && state.type ? state.type : 'form',
      selectedCategory._id,
      () => setDeleteCategoryDialog(false),
      (err) => onError(err)
    );
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const filteredCategories = applySortFilter(
    categoryListData,
    getComparator(order, orderBy),
  );

  return (
    <div className={classes.container}>
      <TableToolbox
        isBack
        isLabel
        isPrimaryButton
        labelText={Strings.CATEGORY_TYPES}
        onClickBack={() => navigate(-1)}
        onNewClick={() => setNewDialog(true)}
      />
      <div className={classes.list_container}>
        {props.categoryListLoading ? (
          <div className={classes.flexView}>
            <CircularProgress
              style={{
                color: theme.palette.background_button,
              }}
            />
          </div>
        ) : (
          <>
            {categoryListData.length === 0 ? (
              <div className={classes.flexView}>
                <p className={classes.no_data_message}>
                  {Strings.NO_DATA_FOUND}
                </p>
              </div>
            ) : (
              <TableContainer>
                <Table sx={{ minWidth: 700 }} aria-labelledby='tableTitle'>
                  <EnhancedTableHead
                    headCells={headCells}
                    handleRequestSort={handleRequestSort}
                    order={order}
                    orderBy={orderBy}
                  />
                  <TableBody>
                    {categoryListData && filteredCategories?.map((data, index) => {
                      const { categoryName, status } = data;
                      return (
                        <TableRow key={data._id} sx={{ width: '100%' }}>
                          <TableCell
                            style={{ ...tableCell(theme) }}
                            component='td'
                            scope='row'
                          >
                            <Stack
                              paddingTop={2.5}
                              direction='column'
                              alignItems='flex-start'
                            >
                              <label className={classes.common_cell}>
                                {categoryName}
                              </label>
                            </Stack>
                          </TableCell>
                          <TableCell
                            style={{ ...tableCell(theme) }}
                            component='td'
                            scope='row'
                          >
                            <Stack
                              paddingTop={2.5}
                              direction='column'
                              alignItems='flex-start'
                            >
                              <label className={classes.common_cell}>
                                {status}
                              </label>
                            </Stack>
                          </TableCell>
                          <TableCell
                            style={{ ...tableCell(theme) }}
                            component='td'
                            scope='row'
                          >
                            <Stack
                              paddingTop={2.5}
                              direction='row'
                              alignItems='center'
                              justifyContent='end'
                            >
                              <CustomizedTooltips
                                title={Strings.EDIT_CATEGORY_TYPE}
                              >
                                <img
                                  className={classes.action_icons}
                                  style={{ marginRight: 15 }}
                                  src={icons(theme).editIcon}
                                  alt=''
                                  onClick={(e) => {
                                    setIsEdit(true);
                                    setSelectedCategory(data);
                                    setNewDialog(true);
                                  }}
                                />
                              </CustomizedTooltips>
                              <CustomizedTooltips
                                title={Strings.DELETE_CATEGORY_TYPE}
                              >
                                <img
                                  className={classes.action_icons}
                                  src={icons(theme).deleteIcon}
                                  alt=''
                                  onClick={(e) => {
                                    setSelectedCategory(data);
                                    setDeleteCategoryDialog(true);
                                  }}
                                />
                              </CustomizedTooltips>
                            </Stack>
                          </TableCell>
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )}
      </div>
      {deleteCategorytDialog && (
        <CommonDialog
          title={Strings.CATEGORY}
          message={Strings.DELETE_CATEGORY}
          onSuccess={() => onDeleteData()}
          onClose={() => {
            setDeleteCategoryDialog(false);
          }}
          loading={props.deleteCategoryLoading}
        />
      )}
      {newDialog && (
        <NewCategoryType
          data={selectedCategory}
          onNewClose={() => {
            setIsEdit(false);
            setNewDialog(false);
          }}
          type={state && state.type ? state.type : 'form'}
          isEdit={isEdit}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  addCategoryData: state.addCategoryData.data,
  categoryListData: state.categoryListData.data,
  categoryListLoading: state.categoryListData.loading,
  deleteCategoryLoading: state.deleteCategoryData.loading,
  deleteCategoryData: state.deleteCategoryData.data,
  updateCategoryData: state.updateCategoryData.data,
});

export default connect(mapStateToProps, {
  fetchCategoryList,
  deleteCategory,
})(CategoryTypes);
